import { render } from "./BillAgeAnalysisReport.vue?vue&type=template&id=432b9021&scoped=true"
import script from "./BillAgeAnalysisReport.vue?vue&type=script&lang=js"
export * from "./BillAgeAnalysisReport.vue?vue&type=script&lang=js"

import "./BillAgeAnalysisReport.vue?vue&type=style&index=0&id=432b9021&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abbas\\Desktop\\kswc\\kswc_dashboard-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-432b9021"]])

export default __exports__